/**
 * Formats a number with comma separators for thousands.
 * @param value - The number to format (can be number, string, null, or undefined)
 * @returns Formatted string with comma separators (e.g., "1,000,000")
 */
export const formatNumber = (
    value: number | string | null | undefined,
): string => {
    if (value === null || value === undefined) {
        return "0";
    }

    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) {
        return "0";
    }

    return numValue.toLocaleString("en-US");
};
